import React from "react"
import Content from "./content-section"
import Locations from "./locations"
import Portal from "./portal"
import Alert from "./alert"
import Tableau from "./tableau"
import Form from "./form"
import Policy from "./policy"

const Sections = ({ props, translations }) => {
  const { sections, flipSections } = props
  const sectionsLength = sections.length
  if (!sections || !sectionsLength) {
    return null
  }
  let contentCount = 0

  return (
    <>
      {sections.map((section, index) => {
        const fieldGroupName = section?.fieldGroupName
        const sectionTranslations = translations ? translations[index] : null
        if (
          fieldGroupName.includes("Customsections_Sections_Content") &&
          (section?.image || section?.documents?.length === 1)
        ) {
          contentCount++
        }
        if (fieldGroupName) {
          return fieldGroupName.includes("Customsections_Sections_Content") ? (
            <Content props={section} translations={sectionTranslations} hr={sectionsLength > index + 1 && sections[index + 1]?.curves?.topCurve === "none" && section.backgroundColor === sections[index + 1].backgroundColor} index={flipSections ? contentCount + 1 : contentCount} />
          ) : fieldGroupName.includes("Customsections_Sections_Locations") ? (
            <Locations props={section} translations={sectionTranslations} />
          ) : fieldGroupName.includes("Customsections_Sections_Portal") ? (
            <Portal props={section} translations={sectionTranslations} />
          ) : fieldGroupName.includes("Customsections_Sections_Alert") ? (
            <Alert props={section} translations={sectionTranslations} curve={sectionsLength > index + 1 && sections[index + 1]?.curves?.topCurve !== "none"} />
          ) : fieldGroupName.includes("Customsections_Sections_Tableau") ? (
            <Tableau props={section} translations={sectionTranslations} />
          ) : fieldGroupName.includes("Customsections_Sections_Form") ? (
            <Form props={section} translations={sectionTranslations} />
          ) : fieldGroupName.includes(
            "Customsections_Sections_Policy"
          ) ? (
            <Policy props={section} translations={sectionTranslations} index={index} />
          ) : null
        } else {
          return null
        }
      })}
    </>
  )
}

export default Sections
